const BASE_URL: string = process.env.REACT_APP_API_KEY || '';
// const BASE_URL:string="http://localhost:8095";

export const MERCHANT_STORE_FIND_ONE : string = BASE_URL + '/merchant/merchant-store/find-one?id=';
export const MERCHANT_STORE_FIND_MANY: string = BASE_URL + '/merchant/merchant-store/find-many';
export const MERCHANT_STORE_CREATE: string = BASE_URL + '/merchant/merchant-store/create-merchant';
export const MERCHANT_STORE_UPDATE: string = BASE_URL + '/merchant/merchant-store/update?id=';
export const MERCHANT_STORE_UPDATE_LOCATION: string = BASE_URL + '/merchant/merchant-store/update-location-merchant?id=';
export const MERCHANT_STORE_DELETE: string = BASE_URL + '/merchant/merchant-store/delete?id=';